/**************************************************************************************************/
/*   File: /src/app/stores/states/ui/state.ts                                                     */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { User } from '@siag/js-egov-authentication';

import * as fromModels from '../../../shared/models';
import { environment } from '../../../../environments/environment.test-env';

/**
 * The ui state
 */
export interface State {
    /**
     * Available languages
     */
    languages: fromModels.Language[];
    /**
     * Messages
     */
    messages: fromModels.Message[];
    /**
     * True if is changing language
     */
    isLoadingLanguageChange: boolean;
    /**
     * True if is loading dossier status
     */
    isLoadingDossierStatus: boolean;
    /**
     * True if it's loading plan type
     */
    isLoadingPlanTypes: boolean;
    /**
     * True if it's loading ambiti
     */
    isLoadingAmbiti: boolean;
    /**
     * True if is loading geo data types
     */
    isLoadingGeoDataTypes: boolean;
    /**
     * The logged user
     */
    user: User;
    /**
     * The dossier status array
     */
    dossierStatus: fromModels.DossierStatus[];
    /**
     * The plan types array
     */
    planTypes: fromModels.PlanType[];
    /**
     * The ambiti array
     */
    ambiti: fromModels.Ambito[];
    /**
     * The geo file types available
     */
    geoFileTypes: fromModels.GeoFileType[];
}

/**
 * The initial authorization state
 */
export const INITIAL_UI_STATE: State = {
    languages: environment.availableLanguages.map((code) => {
        const language = new fromModels.Language(code);
        language.selected = code === environment.defaultLanguage;
        return language;
    }),
    messages: [],
    isLoadingLanguageChange: false,
    isLoadingDossierStatus: false,
    isLoadingPlanTypes: false,
    isLoadingAmbiti: false,
    isLoadingGeoDataTypes: false,
    user: undefined,
    dossierStatus: [],
    planTypes: [],
    ambiti: [],
    geoFileTypes: []
};

/**
 * The state name
 */
export const STATE_NAME = 'ui';